import React from 'react';
import {Link} from 'react-router-dom';
import { Date } from 'core-js';
class ProductItem extends React.Component{

  
    constructor(props) {
        super(props);
        this.state = { 
            contadorCarrito : 0,
            totalproduc: JSON.parse(localStorage.getItem('total_car')) ? JSON.parse(localStorage.getItem('total_car')) : [] ,
            totalprecio: JSON.parse(localStorage.getItem('total_prec')) ? JSON.parse(localStorage.getItem('total_prec')) : [] ,
            listaCarrito: JSON.parse(localStorage.getItem('Carrito')) ? JSON.parse(localStorage.getItem('Carrito')) : [] ,
            productoCarrito :{
                id : '',
                titulo : '',
                img : '',
                cantidad : '',
                precio : '',
                precio_descuento : '',
                descuento : '',
                proveedor : '',
                stock : '',
              },
        };
    }


    getMainImage = (images, prod_name) =>{

        // Buscar imagen principal
        const main_image = images.find(image =>{
            return image.is_main === 1;
        });

        // Validar si existe la imagen principal
        if(main_image){
            // Rertornar imagen principal
            return (<img src={main_image.thumbnail} alt={prod_name} title={prod_name}/>);
        }

        // En caso de que no exista la imagen principal
        // Retornar imagen del indice 0
        return (<img src={images[0].thumbnail} alt={prod_name} title={prod_name}/>);

    }

    getdias = (fecha_creacion) =>{

      var a=new Date(fecha_creacion);
       var dias = 0;

       var d = new Date();


       var fechaCreacion = new Date(a.getFullYear()+'-'+(a.getMonth()+1)+'-'+a.getDate()).getTime();
        var fechaActual  = new Date(d.getFullYear()+'-'+(d.getMonth()+1)+'-'+d.getDate()).getTime();

        var diff = fechaActual - fechaCreacion;
        dias=diff/(1000*60*60*24);
       return (dias);

    }
    

    
    render(){

        return (
            
            this.props.products.map((prod,index) =>(
                
                <article className="col-6 col-md-3 mt-1 mb-1" >
                    <Link to={`/producto/${prod.slug}`}>
                        <div className="displayproduct text-center">
                            {this.getMainImage(prod.product_images, prod.name)}
                            
                            <div className="div_spam">
                                {this.getdias(prod.created_at) <= 5 ?  <span className="new_prod">Nuevo</span>
                                :""
                                }
                                
                                
                                {prod.descuento>0?
                                <span className="ofert_prod">- {prod.descuento} % </span>
                                : ""
                                }

                                {prod.bim.length>0 ?  <span className="bim_spam">BIM</span>
                                :""
                                }

                                
                            </div>

                            {prod.name}<br/>
                            
                            <span className="text-center">{prod.provider ? prod.provider.name : prod.brand.name }</span>
                          
                            
                        </div>
                        
                        </Link>
                        <div className="d_details">

                        {prod.descuento>0?
                            
                            <span className="precio_prod">S/. {prod.fair_price.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>    
                            :<span className="precio_prod">{prod.price==0 ? "" : "S/. " + prod.price.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>
                        }

                        {prod.descuento>0?
                            
                            <span className="fair_precio_prod">S/. {prod.price.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>     
                            : ""
                        }
                      

                      {prod.price!=0 ? 
                        <button id={"btn"+prod.id} onClick={ this.agregarProducto.bind(this,prod.id,prod.stock,prod.name,prod.price,prod.fair_price,prod.descuento,prod.provider.name,prod.product_images,prod.slug) } className="boton_car_1" disabled={localStorage.getItem("total"+prod.id)==null ? false :true}><i className=""><img className="card_i"  src="/assets/car.png" width="5%"></img></i></button>
                        
                       : ""
                       
                       }

                       
                      <button id={"btn1"+prod.id} style={{display:"none"}} onClick={ this.agregarProducto.bind(this,prod.id,prod.stock,prod.name,prod.price,prod.fair_price,prod.descuento,prod.provider.name,prod.product_images,prod.slug) } className="boton_car_1" disabled={true}><i className=""><img className="card_i"  src="/assets/car.png" width="5%"></img></i></button>
                       
                        </div>
                        {/*<span className="stock_prod" id={"stock"+prod.id}>{prod.stock==0 ? "" : localStorage.getItem("total"+prod.id)==null ? "stock: " + prod.stock :"stock :" + localStorage.getItem("total"+prod.id)}</span>*/}
                            
                            
                            <div id={"div_inbtn"+prod.id} className={ (prod.stock <= 0) ? "btn-i-car d_none" : localStorage.getItem("total"+prod.id)==null?"btn-i-car":"btn-i-car d_none" }>
                            {/*<input type="Number" id={"cant"+prod.id} defaultValue="1" min="1" max={prod.stock} disabled={ (prod.stock <= 0) ? true : false }  ></input>*/}
                           
                              
                            </div>
                            {/*<a href="/shoppingcart"  ><p id={"btn_ver"+prod.id} className={ (prod.stock <= 0) ? "btn_carrito d_none" : localStorage.getItem("total"+prod.id)==null?"d_none btn_carrito":" btn_carrito" }><i className="fas fa-cart-plus"></i>Ver Carrito </p></a> */}
               
                </article>
            ))
        );
    }
 
    agregarProducto = (id,stock,name,precio,precio_descuento,descuento,proveedor,product_images,slug) =>{
       
        var total_car= JSON.parse(localStorage.getItem('total_car'));
        if  (total_car==null || total_car==0 ){
           var carrito =[];
        }else{
            var carrito = JSON.parse(localStorage.getItem('Carrito'));
        }

        //let cantidad = document.querySelector("#cant"+id).value;
        let cantidad =1;
        console.log(id+ " " + stock + " " + name + " " + precio+ " " + cantidad);
        if (Number(cantidad) <=0) {
            alert('Seleccione una cantidad válida');
            return
        }
        
        if(Number(stock) < Number(cantidad)){
            alert('Máxima existencia es: '+ stock);
        }else{
            
            {/*this.state.productoCarrito.id =  id;*/}
            
            {/*this.state.productoCarrito.img =  this.props.img;*/}

            this.state.totalproduc = Number(total_car) + 1 ;
            localStorage.setItem("total_car",this.state.totalproduc);
            /*console.log(localStorage.getItem("total_car"));*/
            
            document.querySelector("#total_product").innerHTML = localStorage.getItem("total_car");

           
           var stock_disponible=stock - cantidad;

            localStorage.setItem("total"+id,stock_disponible);
            //document.querySelector("#stock"+id).innerHTML = "stock: " + localStorage.getItem("total"+id);

            //document.querySelector("#btn"+id).disabled = true;
           // document.querySelector("#div_inbtn"+id).style.display = "none";

            //document.querySelector("#btn_ver"+id).style.display = "block";
            
            document.querySelector("#btn"+id).style.display = "none";
            document.querySelector("#btn1"+id).style.display = "block";

               var producto= { 
                id : id,
                titulo : name,
                img : this.getMainImage(product_images, name),
                slug : slug,
                cantidad : Number(cantidad),
                precio : parseFloat(precio),
                fair_precio:parseFloat(precio_descuento),
                descuento:descuento,
                proveedor : proveedor,
                stock:stock,
                envio:'Null',
                dias:'Null',
                distrito:'',
                distrito_id:'',
               };
               
                /*console.log(listaCarrito);
                console.log("-------------");*/
                
                carrito.push(producto);
                
                localStorage.setItem("Carrito",JSON.stringify(carrito));

           // }
           /*var carrito = JSON.parse(localStorage.getItem("Carrito"));
            
           var producto= this.state.productoCarrito;
            var carrito = carrito.push(producto);
            console.log(carrito);*/
          /* localStorage.setItem("Carrito",JSON.stringify(this.state.productoCarrito));*/

          
          var total=0;
          var precio=0;
          for(let numero in carrito){
              if(Number(carrito[numero].descuento)>0){
                  precio= carrito[numero].fair_precio;
              }else{
                precio=carrito[numero].precio;
              }
              total = total + (carrito[numero].cantidad * precio);
          }
          localStorage.setItem("total_prec",total);

          
          localStorage.setItem("total_pago",-2);
          localStorage.setItem("total_envio",-2);   
           
        }
    }

  


    

}
export default ProductItem;